import type {DeepKeyIn} from '../../utils/utility-types';

export const size = {
  borderRadius: {
    la: 16,
    me: 12,
    sm: 8,
    xl: 20,
    xs: 4,
    xxl: 24,
  },
  gap: {
    la: 16,
    me: 12,
    sm: 8,
    xl: 20,
    xs: 4,
    xxl: 24,
    xxxl: 30,
  },
  padding: {
    la: 16,
    me: 12,
    sm: 8,
    xl: 20,
    xs: 4,
    xxl: 24,
    xxxl: 30,
  },
};

export type SizeFor<T extends keyof Sizes> = keyof Sizes[T];

export type Sizes = typeof size;

export type ThemeSize = DeepKeyIn<Sizes>;
